import { FieldValidationError } from './FieldValidationError'

/**
 * `GitHubTokenValidationError` is an extended `FieldValidationError`
 * that includes additional information about failed validation of
 * GitHub access token (for example, missing scopes).
 */
export class GitHubTokenValidationError extends FieldValidationError {
  missingScopes?: string[]
  isGitHubTokenValidationError = true

  constructor({
    fieldName,
    missingScopes,
    message,
  }: {
    fieldName: string
    missingScopes?: string[]
    message?: string
  }) {
    super({ fieldName, message })
    this.name = 'GitHubTokenValidationError'
    this.missingScopes = missingScopes
  }
}
